/**
 * Аналитика для карты
 * Все эвенты описаны в документе
 * @see https://docs.google.com/spreadsheets/d/1ZJftJ2drwj6rNFlf2tjmUkHM7QpfX4T6e0kQwTAiMng/edit#gid=0
 */

import { dataLayerPush } from 'src/helpers/gtm';
import type { HotelState } from 'src/routes/SearchPage/store/map/types';

export const pushMapExpanded = (isExpanded: boolean) => {
  const event = isExpanded ? 'map_collapsed' : 'map_extended';

  dataLayerPush({ event, map_type: 'yandex' });
};

export const pushMapOpened = () => {
  dataLayerPush({ event: 'map_opened', map_type: 'yandex' });
};

export const pushMapHotelCardPopup = (
  isMobile: boolean,
  popupDataState: HotelState,
) => {
  dataLayerPush({
    event: isMobile ? 'hotel_click' : 'hotel_hovered',
    map_type: 'yandex',
    type: popupDataState,
  });
};

export const pushHotelClicked = () => {
  dataLayerPush({
    event: 'hotel_clicked',
  });
};

export const pushMapError = (
  error: Error,
  componentStack: string,
  eventId: string,
) => {
  dataLayerPush({
    event: 'map_error',
    map_type: 'yandex',
    error: JSON.stringify({
      name: error.name,
      message: error.message,
      stack: error.stack,
      cause: error.cause,
      componentStack,
      eventId,
    }),
  });
};
